import { ClientBrandCode } from '@domgen/dgx-fe-common';
import { ApplianceDetailsSteppedFormValue } from './appliance-details-stepped-form-value.type';
import { CmsApplianceDetailsSteppedForm } from './cms-appliance-details-stepped-form.interface';

export interface ApplianceDetailsSteppedFormConfig {
  applianceMaximumAge: Date;
  clientBrandCode?: ClientBrandCode;
  cmsData: CmsApplianceDetailsSteppedForm;
  initialValue: Partial<ApplianceDetailsSteppedFormValue>;
}
